import { Box, Button, Container, Divider, Fade, Slide, Stack, Typography } from "@mui/material";
import Marquee from "react-fast-marquee";
import { useEffect, useState, useRef } from "react";

import HeroBackgroundNyc from '../common/static/nyc_exposure_stop_0.25_q70.webp';
import HeroBackgroundSgp from '../common/static/sgp_exposure_stop_0.25_q70.webp';
import HeroBackgroundHk from '../common/static/hk_exposure_stop_0.25_q70.webp';
import HeroDeepKpiWebp from './webp/hero_deepkpi.webp';
import HeroReportsWebp from './webp/hero_reports.webp';

import HeptagonsSVG from '../common/static/pattern_heptagons.svg';

import BofaLogo from './webp/bofa_logo.webp'
import ExoduspointLogo from './webp/exoduspoint_logo.webp'
import FtserussellLogo from './webp/lseg-ftse-russell_logo.webp'
import WorldquantLogo from './webp/worldquant_logo.webp'
import BlackrockLogo from './webp/blackrock_logo.webp'
import BlackstoneLogo from './webp/blackstone_logo.webp'
import CarlyleLogo from './webp/carlyle_logo.webp'
import CitiLogo from './webp/citi_logo.webp'
import EvercoreLogo from './webp/evercore_logo.webp'
import GsLogo from './webp/gs_logo.webp'
import HsbcLogo from './webp/hsbc_logo.webp'
import JpmLogo from './webp/jpm_logo.webp'
import Point72Logo from './webp/point72_logo.webp'
import SpLogo from './webp/sp_logo.webp'
import TdLogo from './webp/td_logo.webp'
import TriumcapitalLogo from './webp/triumcapital_logo.webp'
import UbsLogo from './webp/ubs_logo.webp'

import { ampli, RevelataFooter, trackRedditEvent } from '../common';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate } from 'react-router-dom';

import { VideoComponent } from '../common/VideoComponent';

export function Home() {
    const { authStatus, route } = useAuthenticator((context) => [context.authStatus, context.route]);

    useEffect(() => {
        trackRedditEvent('PageVisit');
    }, []);

    function onClickSignUpButton() {
        ampli.wwwWebappSignUpButtonClick({ "Button Location": "main" });
        return;
    }

    function ResponsiveLede() {
        // const text_headline = <>Become bionic at<br/>investment research & analysis<br/></>
        // const text_subheadline = <>Our AI platform enables you to do company research and<br/>financial modeling better and faster than ever before.</>
        // const text_headline = <>Become bionic at investment research & analysis</>
        // const text_headline = <>Data-driven, understandable investment research & analysis</>
        // const text_headline = <>Data-driven, explainable investment research & analysis</>
        // const text_headline = <>Better, faster, data-driven investment research & analysis</>        
        const text_headline = <>Fundamental global equities analysis<br />made easy</>
        const text_subheadline = <>Nuanced company KPI data found nowhere else.<br />100% auditable and explainable answers.<br />Effortless modeling in Excel.<br /><br />No hype.&nbsp;&nbsp;Just disciplined insight.</>

        // Array of background images to rotate through
        const backgroundImages = [
            HeroBackgroundNyc,
            HeroBackgroundSgp,
            HeroBackgroundHk
        ];

        const [currentImageIndex, setCurrentImageIndex] = useState(0);
        const [nextImageIndex, setNextImageIndex] = useState(1);
        const [isTransitioning, setIsTransitioning] = useState(false);

        useEffect(() => {
            const rotationInterval = setInterval(() => {
                setNextImageIndex((currentImageIndex + 1) % backgroundImages.length);
                setIsTransitioning(true);
                
                // After transition completes, update current index
                setTimeout(() => {
                    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
                    setIsTransitioning(false);
                }, 3000); // Match the CSS transition duration
            }, 10000); // Rotate every 10 seconds

            return () => clearInterval(rotationInterval);
        }, [currentImageIndex, backgroundImages.length]);

        return (
            <Box sx={{
                position: 'relative',
                border: '0px solid blue',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                overflow: 'hidden',
                height: { xs: 'max-content', md: '60%', lg: '80%', xl: '90%' },
            }}
            >
                {/* Background layer 1 - current image */}
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${backgroundImages[currentImageIndex]})`,
                    opacity: isTransitioning ? 0 : 1,
                    transition: 'opacity 3s ease-in-out',
                    zIndex: 0,
                }}
                />
                {/* Background layer 2 - next image (cross-fades in) */}
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${backgroundImages[nextImageIndex]})`,
                    opacity: isTransitioning ? 1 : 0,
                    transition: 'opacity 3s ease-in-out',
                    zIndex: 0,
                }}
                />
                {/* Content layer that stays visible */}
                <Fade in={true} timeout={1200}>
                    <Box sx={{
                        position: 'relative',
                        zIndex: 1,
                        width: { xs: '100%', md: '80%' },
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: { xs: 'center', md: 'center' },
                        alignItems: { xs: 'center', md: 'flex-start' },
                        border: '0px solid green',
                        pt: { xs: 2, md: 0 },
                        pl: { xs: 2, md: 5, lg: 10, xl: 20 },
                        pr: { xs: 2, md: 2 },
                        minHeight: { xs: '300px', md: '100%' }
                    }}>
                        <Typography variant="h1" sx={{
                            fontSize: { xs: "24px", sm: "32px", md: "40px", lg: "48px", xl: "72px" },
                            textAlign: { xs: 'center', md: 'left' },
                            // pr: { xs: 2, md: 5, lg: 10, xl: 30},        
                        }}>
                            {text_headline}
                        </Typography>
                        <Typography variant="h5" fontWeight="400" sx={{
                            fontSize: { xs: "14px", sm: "18px", md: "18px", lg: "22px", xl: "24px" },
                            mt: { xs: 3, md: 5 },
                            color: "#CBCBCB",
                            textAlign: { xs: 'center', md: 'left' },
                            // pr: { xs: 2, md: 5, lg: 10, xl: 30},        
                        }}>
                            {text_subheadline}
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: { xs: 'center', md: 'left' },
                            mt: { xs: 4, md: 8 },
                            mb: { xs: 2 },
                            // pr: { xs: 2, md: 5, lg: 10, xl: 30},

                        }}>
                            <Button
                                variant='contained'
                                sx={{ borderRadius: 50, pl: 4, pr: 4, fontWeight: 'bold' }}
                                size="large"
                                href="/signup"
                                onClick={() => onClickSignUpButton("main")}>
                                Free Trial
                            </Button>
                        </Box>
                    </Box>
                </Fade>
                {/* <Slide direction="left" in={true} timeout={1200} easing="cubic-bezier(0.4, 0, 0.2, 1)">
                    <Box sx={{
                        mt: { xs: 0, md: 15 },
                        display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex' },
                        justifyContent: { md: 'flex-end' },
                        alignItems: { md: 'flex-end' },
                        width: { md: '48%' }
                    }}>
                        <img
                            src={HeroHomepageWebp} // Replace with the URL or path to your image
                            style={{ width: '100%', objectFit: 'cover' }}
                            alt="Revelata homepage"
                        />
                    </Box>
                </Slide> */}
                {/* <Fade in={true} timeout={2400}>
                    <Box sx={{
                        mt: { xs: 2 },
                        display: { xs: 'flex', sm: 'flex', md: 'none', lg: 'none', xl: 'none' },
                        justifyContent: { xs: "center" },
                        alignItems: { xs: "center" },
                        width: { xs: '100%' }
                    }}>
                        <img
                            src={HeroHomepageWebp} // Replace with the URL or path to your image
                            style={{ width: '75%', objectFit: 'cover' }}
                            alt="Revelata homepage"
                        />
                    </Box>
                </Fade> */}
            </Box>
        )
    }

    function ResponsiveMarqueeSection() {
        const logos = [
            { src: BlackstoneLogo, alt: 'Blackstone Logo' },
            { src: JpmLogo, alt: 'JPM Logo' },
            { src: CitiLogo, alt: 'Citi Logo' },
            { src: GsLogo, alt: 'GS Logo' },
            { src: HsbcLogo, alt: 'HSBC Logo' },
            { src: UbsLogo, alt: 'UBS Logo' },
            { src: TdLogo, alt: 'TD Logo' },
            { src: EvercoreLogo, alt: 'Evercore Logo' },
            { src: Point72Logo, alt: 'Point72 Logo' },
            { src: CarlyleLogo, alt: 'Carlyle Logo' },
            { src: TriumcapitalLogo, alt: 'Triumcapital Logo' },
            { src: SpLogo, alt: 'SP Logo' },
            { src: WorldquantLogo, alt: 'Worldquant Logo' },
            { src: ExoduspointLogo, alt: 'Exoduspoint Logo' },
            { src: FtserussellLogo, alt: 'Ftserussell Logo' },
            { src: BofaLogo, alt: 'Bofa Logo' },
            { src: BlackrockLogo, alt: 'Blackrock Logo' },
        ];

        return (
            <>
                <Stack sx={{ display: { xs: 'none', md: 'flex', lg: 'flex' }, mt: { md: 2 }, mb: { md: 12 } }} alignItems="center" justifyContent="center">
                    <Typography variant="h6" sx={{ fontSize: { xs: "12px", md: "24px" }, fontWeight: "600", mb: { xs: 3, md: 6 }, mt: { xs: 2, md: 4 } }}>
                        Developed with experts from:
                    </Typography>
                    <Marquee speed="25" autoFill gradient gradientColor='#0d0d0d' gradientWidth={100}>
                        {logos.map((logo, index) => (
                            <img
                                key={index}
                                alt={logo.alt}
                                src={logo.src}
                                style={{ height: "32px", marginRight: "64px" }} // Add margin-right
                            />
                        ))}
                    </Marquee>
                </Stack>
                <Stack sx={{ display: { xs: 'flex', md: 'none', lg: 'none' }, m: { xs: 6 } }} alignItems="center" justifyContent="center">
                    <Typography variant="h6" sx={{ fontSize: { xs: "12px", md: "24px" }, fontWeight: "600", mb: { xs: 3, md: 6 }, mt: { xs: 2, md: 4 } }}>
                        Developed with experts from:
                    </Typography>
                    <Marquee speed="25" autoFill>
                        {logos.map((logo, index) => (
                            <img
                                key={index}
                                alt={logo.alt}
                                src={logo.src}
                                style={{ height: "16px", marginRight: "32px" }} // Add margin-right
                            />
                        ))}
                    </Marquee>
                </Stack>
            </>
        );
    }

    function ResponsiveProductsSection() {

        const onClickLearnMoreButton = (header) => {
            // ampli.signUpButtonClick({ "Button Location": header});             
            ampli.wwwWebappSignUpButtonClick({ "Button Location": header });
            return;
        }

        function useOnScreen(ref, rootMargin = '-100px') {
            const [isIntersecting, setIntersecting] = useState(false);

            useEffect(() => {
                const observer = new IntersectionObserver(
                    ([entry]) => {
                        setIntersecting(entry.isIntersecting);
                    },
                    { rootMargin }
                );
                if (ref.current) {
                    observer.observe(ref.current);
                }
                return () => {
                    if (ref.current) {
                        observer.unobserve(ref.current);
                    }
                };
            }, [ref, rootMargin]);

            return isIntersecting;
        }

        function ResponsiveSection({ section_id, productName, product, text2, text3, feature_cards, section_img, productUrl, productCtaButtonText }) {
            const desktopRef = useRef(null);
            const mobileRef = useRef(null);
            const isOnScreenDesktop = useOnScreen(desktopRef);
            const isOnScreenMobile = useOnScreen(mobileRef);

            // console.log(isOnScreenDesktop, isOnScreenMobile);
            return (
                <>
                    {/* Mobile */}
                    <div ref={mobileRef}>
                        <Fade in={isOnScreenMobile} timeout={1200}>
                            <Stack sx={{ display: { xs: 'flex', md: 'none' }, flexDirection: { xs: 'column' } }}>
                                <Divider />
                                <Box sx={{ p: 4 }}>
                                    <Typography variant="h4" sx={{ fontSize: { xs: "18px", fontWeight: 600 }, textAlign: { xs: 'left' } }}>
                                        {product}
                                    </Typography>
                                    <Typography variant="h5" fontWeight="400" sx={{ fontSize: { xs: "14px" }, mt: { xs: 1 }, color: "#CBCBCB", textAlign: { xs: 'left' } }}>
                                        {text3}
                                    </Typography>
                                    {feature_cards}
                                </Box>                                
                                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "90%", mx: 'auto' }}>
                                    {section_img}
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: { xs: 'center' }, mt: { xs: 3 }, mb: { xs: 3 }, border: '0px solid red' }}>
                                    <Button variant="outlined" sx={{
                                        borderColor: "white",
                                        color: "white",
                                        textTransform: "none",
                                        width: { xs: "medium", md: "medium" }, // Set a fixed width for medium size (adjust if needed)
                                        borderRadius: 50,
                                        fontWeight: "600",
                                    }} href={productUrl} onClick={() => onClickLearnMoreButton(productName)}>
                                        {productCtaButtonText}
                                    </Button>
                                </Box>
                            </Stack>
                        </Fade>
                    </div>

                    {/* Desktop */}
                    <div ref={desktopRef}>
                        <Fade in={isOnScreenDesktop} timeout={1200}>
                            <Stack sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: { md: 'row' }, gap: 8, pt: 6, pb: 6, mx: 'auto', border: '0px solid red' }}>
                                <Box
                                    sx={{
                                        display: { xs: 'none', md: 'block' },
                                        width: { md: '50%' },
                                        alignItems: 'stretch',
                                    }}
                                >
                                    {section_id % 2 === 1 ?
                                        <Box>
                                            <Typography variant="h4" sx={{ fontSize: { md: "32px", xl: "36px", fontWeight: 600 }, textAlign: { md: 'left' } }}>
                                                {product}
                                            </Typography>
                                            <Typography variant="h5" sx={{ fontSize: { md: "16px", xl: "22px" }, fontWeight: 400, mt: { md: 5 }, color: "#CBCBCB", textAlign: { xs: 'center', md: 'left' } }}>
                                                {text3}
                                            </Typography>
                                            {feature_cards}
                                            <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'left' }, mt: { xs: 4, md: 8 } }}>
                                                <Button variant="outlined" sx={{
                                                    borderColor: "white",
                                                    color: "white",
                                                    textTransform: "none",
                                                    width: "medium", // Set a fixed width for medium size (adjust if needed)
                                                    borderRadius: 50,
                                                    fontWeight: "600",
                                                }} href={productUrl} onClick={() => onClickLearnMoreButton(productName)}>
                                                    {productCtaButtonText}
                                                </Button>
                                            </Box>
                                        </Box>
                                        :
                                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "100%", mx: 'auto' }}>
                                            {section_img}
                                        </Box>
                                    }

                                </Box>
                                <Box
                                    sx={{
                                        display: { xs: 'none', md: 'block' },
                                        width: { md: '50%' },
                                        alignItems: 'stretch',
                                        // p: { md: 4 },
                                        // pl: { md: 5, lg: 10, xl: 20 },
                                        // pr: { md: 10, lg: 10, xl: 20 },
                                        // mt: { md: 6 },
                                    }}
                                >
                                    {section_id % 2 === 1 ?
                                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "90%", mx: 'auto' }}>
                                            {section_img}
                                        </Box>
                                        :
                                        <Box>
                                            <Typography variant="h4" sx={{ fontSize: { md: "32px", xl: "36px", fontWeight: 600 } }}>
                                                {product}
                                            </Typography>
                                            <Typography variant="h5" sx={{ fontSize: { md: "16px", xl: "22px" }, fontWeight: 400, mt: { md: 5 }, color: "#CBCBCB", textAlign: { xs: 'center', md: 'left' } }}>
                                                {text3}
                                            </Typography>
                                            {feature_cards}
                                            <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'left' }, mt: { xs: 4, md: 8 } }}>
                                                <Button variant="outlined" sx={{
                                                    borderColor: "white",
                                                    color: "white",
                                                    textTransform: "none",
                                                    width: "medium", // Set a fixed width for medium size (adjust if needed)
                                                    borderRadius: 50,
                                                    fontWeight: "600",
                                                }} href={productUrl} onClick={() => onClickLearnMoreButton(product)}>
                                                    {productCtaButtonText}
                                                </Button>
                                            </Box>
                                        </Box>
                                    }
                                </Box>
                            </Stack>
                        </Fade>
                    </div>
                </>
            )
        }


        function FeatureCards({ feature_cards_content }) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row', //{ xs: 'column', md: 'row' },
                        flexWrap: 'wrap', //{ xs: 'nowrap', md: 'wrap' },
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: {'xs': '100%', sm: '70%', 'md': '100%'},                        
                        mx: 'auto',                        
                        gap: { xs: 1, sm: 2,md: 3 },
                    }}
                >
                    {Array.isArray(feature_cards_content)
                        ? feature_cards_content.map((content, idx) => (
                            <Box
                                key={idx}
                                sx={{
                                    flex: { xs: '1 1 30%', md: '1 1 30%' }, // About 3 per row
                                    minWidth: 0, //{ xs: '100%', md: 0 },
                                    maxWidth: '32%', //{ md: '32%' },
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    background: 'rgba(255,255,255,0.06)',
                                    borderRadius: '6px',
                                    border: '1px solid rgba(255,255,255,0.14)',
                                    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                    height: '100%', // ensures it will fill parent
                                    minHeight: {xs: 100, md: 120}, // fallback, will be overridden in parent                        
                                    maxHeight: {xs: 100, md: 120},
                                    p: { xs: 1, md: 2 },
                                    textAlign: 'center',
                                }}
                            >
                                <Typography variant="body1" sx={{  fontSize: { xs: "12px",  xl: "16px" }, fontWeight: 400, color: '#FFFFFF' }}>
                                    {content}
                                </Typography>
                            </Box>
                        ))
                        : feature_cards_content
                    }
                </Box>
            )
        }

        const deepkpi_section_props = {
            section_id: 0,
            productName: "deepKPI",
            product: "deepKPI", //"Cut days down to seconds.", 
            text3: <>
                <p>Build financial models with better data, faster.</p>
                <p>Stop manually scrape disclosures.&nbsp;&nbsp;We've already extracted all time series data from key SEC filings (10-K, 10-Q, 8-K) & global company disclosures, delivering the most comprehensive set of nuanced, company-specific KPIs available anywhere.</p>
                </>,
            feature_cards: <FeatureCards feature_cards_content={
                [
                    "1-click audit for every data point", 
                    "Pull data into models with our Excel add-in", 
                    "Cover the U.S., Hong Kong, Singapore & more"
                ]}
            />,
            section_img: <img src={HeroDeepKpiWebp} style={{ width: "100%" }} alt="deepKPI" />,
            productUrl: process.env.REACT_APP_DEEPKPI_URL,
            productCtaButtonText: "See coverage details"
        };

        const deepanalysis_section_props = {
            section_id: 1,
            productName: "deepAnalysis",
            product: <Box sx={{ display: 'flex', flexDirection: 'row' }}>deepAnalysis</Box>, // "Audit every data point with one click.", 
            //text3: <><p>Quickly ramp up on any public company.</p><p>Get complex questions answered fast by simply asking our AI.&nbsp;&nbsp;It'll search through billions of pages of SEC filings, earnings call transcripts, as well as deepKPI time series, to produce the right answers, complete with precise citations.</p></>,
            text3: <><p>Get precise answers to complex questions.</p><p>Our specialized AI analyzes information from billions of pages of public disclosures, earnings transcripts, and deepKPI time series to give nuanced answers with exact citations to source documents.</p></>,
            feature_cards: <FeatureCards feature_cards_content={
                [
                    "Pinpoint the right facts immediately", 
                    "Draft cogent reports with inline citations", 
                    "Build models in Excel 20X faster"
                ]}
            />,
            section_img: <VideoComponent videoUrl={`${process.env.REACT_APP_STATIC_WWW_URL}/assets/deepanalysis/mp4/hero_da.mp4`} style={{ borderRadius: '12px' }}/>,
            productUrl: process.env.REACT_APP_DEEPANALYSIS_URL,
            productCtaButtonText: "Watch it in action"
        };

        const deepinsight_section_props = {
            section_id: 2,
            productName: "deepInsight",
            product: "deepInsight",
            text3: <><p>You can't outsource diligence, but this is the next best thing.</p><p>Institutional-quality research reports featuring cogent, data-driven analyses, accompanied by granular financial models&mdash;all driven by our deepKPI data, so you can drill right down to the source.</p><p>Use our research and models directly for your comps, or to jump-start your own custom analyses.</p></>,
            feature_cards: null,
            section_img: (
                <Box sx={{ position: "relative", width: "100%" }}>
                    <img
                        src={HeroReportsWebp}
                        style={{
                            width: "100%",
                            maxHeight: '500px',
                            objectFit: "cover",
                            objectPosition: "top",
                            borderTopLeftRadius: "6px",
                            borderTopRightRadius: "6px",
                            display: "block",
                        }}
                        alt="deepInsight"
                    />
                    <Box
                        sx={{
                            position: "absolute",
                            left: 0,
                            right: 0,
                            bottom: 0,
                            height: "40%",
                            borderTopLeftRadius: "0px",
                            borderTopRightRadius: "0px",
                            pointerEvents: "none",
                            zIndex: 1,
                            background: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.85) 100%)"
                        }}
                    />
                </Box>
            ),
            productUrl: process.env.REACT_APP_DEEPINSIGHT_URL,
            productCtaButtonText: "Download Free Samples"
        };

        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '0px solid red',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '1000px 1000px', // Adjust the dimensions as needed
                    backgroundPosition: '130% 140%', // Adjust the values as needed
                    backgroundImage: `url(${HeptagonsSVG})`,
                }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: { xs: '100%', md: '90%', lg: '80%', xl: '60%' },
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: 1, md: 4 }
                }}>
                    <ResponsiveSection {...deepkpi_section_props} />
                    <ResponsiveSection {...deepanalysis_section_props} />
                    <ResponsiveSection {...deepinsight_section_props} />
                </Box>
            </Box>
        )
    }


    function ResponsiveTestimonialsSection() {
        const testimonials = [
            {
                quote: "This is wild. It saves so much time.",
                author: "Associate",
                company: "Global Bulge Bracket Investment Bank"
            },
            {
                quote: "Contemplated outsourcing model building... but this really impacted our decision. ",
                author: "Investor",
                company: "New L/S Hedge Fund"
            },
            {
                quote: "Shared with my co-worker, so we can start using Revelata for companies in our coverage.",
                author: "Advisor",
                company: "Automotive Advisory Firm"
            },
            {
                quote: "What's unique? Finding very niche operational data within 10-K's that's not captured by other platforms.",
                author: "Equity Research Analyst",
                company: "Tier 1 APAC Investment Bank"
            },
        ];

        const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
        const [fadeIn, setFadeIn] = useState(true);

        useEffect(() => {
            const rotationInterval = setInterval(() => {
                setFadeIn(false);
                setTimeout(() => {
                    setCurrentTestimonialIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
                    setFadeIn(true);
                }, 800); // Wait for fade-out before changing testimonial
            }, 8000); // Show each testimonial for 8 seconds

            return () => clearInterval(rotationInterval);
        }, [testimonials.length]);

        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: { xs: 4, md: 4 },
            }}>
                <Typography variant="h6" sx={{ fontSize: { xs: "18px", md: "36px" }, fontWeight: "600", mb: { xs: 1, md: 4} }}>
                    What Our Users Are Saying
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',                        
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        width: '100%',
                        minHeight: { xs: '14em', md: '16em' },
                        height: { xs: '14em', md: '16em' },
                        boxSizing: 'border-box',
                    }}
                >
                    <Fade in={fadeIn} timeout={800}>
                        <Box sx={{
                            width: { xs: '80%', sm: '70%', md: '60%', lg: '50%', xl: '40%' },
                            minWidth: { xs: '300px' },
                            minHeight: { xs: '8em', md: '12.5em' }, // Use em for relative min height
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '6px',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            p: { xs: 2, md: 3 },
                            backdropFilter: 'blur(10px)',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                        }}>
                            <Typography variant="h6" sx={{
                                fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "20px", xl: "24px" },
                                color: 'var(--brand-main)',
                                mb: 0,
                                lineHeight: 1.6,
                            }}>
                                "{testimonials[currentTestimonialIndex].quote}"
                            </Typography>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-end',
                                mt: { xs: 1, md: 2 },
                            }}>
                                <Typography variant="body1" sx={{
                                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                                    fontWeight: 600,
                                    color: '#FFFFFF',
                                }}>
                                    {testimonials[currentTestimonialIndex].author}
                                </Typography>
                                <Typography variant="body2" sx={{
                                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                                    color: '#CBCBCB',
                                    mt: 0.5,
                                }}>
                                    {testimonials[currentTestimonialIndex].company}
                                </Typography>
                            </Box>
                        </Box>
                    </Fade>

                    {/* Indicator dots */}
                    <Box sx={{
                        display: 'flex',
                        gap: 1.5,
                        p: { xs: 2, md: 2 },
                    }}>
                        {testimonials.map((_, index) => (
                            <Box
                                key={index}
                                sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    backgroundColor: index === currentTestimonialIndex ? '#FFFFFF' : 'rgba(255, 255, 255, 0.3)',
                                    transition: 'background-color 0.3s ease',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    setFadeIn(false);
                                    setTimeout(() => {
                                        setCurrentTestimonialIndex(index);
                                        setFadeIn(true);
                                    }, 800);
                                }}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
        )
    }

    if (authStatus === 'authenticated') {
        return <Navigate to="/dashboard" />;
    }

    if (authStatus === 'unauthenticated') {
        return (
            <Container disableGutters maxWidth="false">
                <ResponsiveLede />
                <ResponsiveTestimonialsSection />
                <ResponsiveProductsSection />
                <ResponsiveMarqueeSection />
                <Divider />
                <RevelataFooter />
            </Container>
        )
    }

    return null;
}

export default Home;